import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import {
  collectDestinationCidrs,
  destinationSchema,
} from "./egressRouteShared";
import { mutator } from "./mutator";

export const updateEgressRouteSchema = z.object({
  id: z.string(),
  destination: destinationSchema,
  enforced: z.boolean().optional(),
});

export const updateEgressRoute = mutator({
  schema: updateEgressRouteSchema,
  resolve: { egressRoute: { kind: "egressRoute", from: "id" } },
  permissions: [
    {
      permission: "tenant:egress_routes_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "network:use",
      scopeId: ({ args }) => args.egressRoute.network.id,
    },
  ],
  fn: async ({ tx, args: { destination, enforced, egressRoute } }) => {
    const { network } = egressRoute;
    const value =
      destination.type === "cidr" ? destination.range : destination.pattern;
    await tx.mutate.egressRoutes.update({
      id: egressRoute.id,
      destinationType: destination.type,
      destination: value,
      enforced: enforced ?? egressRoute.enforced,
    });
    const existing = await tx.run(
      zql.egressRoutes.where("networkId", network.id)
    );
    const next = existing.map((r) =>
      r.id === egressRoute.id
        ? { destinationType: destination.type, destination: value }
        : r
    );
    await tx.mutate.networks.update({
      id: network.id,
      configuration: {
        ...network.configuration,
        destinationCidrs: collectDestinationCidrs(next),
      },
    });
  },
});
